var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1191 16C15.3533 16 15.5779 15.907 15.7435 15.7414C15.909 15.5758 16.0021 15.3512 16.0021 15.117V0.883C16.0021 0.648814 15.909 0.424219 15.7435 0.258625C15.5779 0.0930301 15.3533 0 15.1191 0L0.885075 0C0.650889 0 0.426295 0.0930301 0.2607 0.258625C0.0951053 0.424219 0.0020752 0.648814 0.0020752 0.883L0.0020752 15.117C0.0020752 15.3512 0.0951053 15.5758 0.2607 15.7414C0.426295 15.907 0.650889 16 0.885075 16H15.1191Z",
    fill: "#485A96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0421 15.9999V9.80692H13.1221L13.4331 7.39192H11.0421V5.84792C11.0421 5.14792 11.2361 4.67192 12.2421 4.67192H13.5211V2.51192C12.9024 2.44473 12.2804 2.41135 11.6581 2.41192C11.2349 2.38123 10.8101 2.44347 10.4134 2.59427C10.0168 2.74507 9.65796 2.98079 9.36204 3.2849C9.06612 3.58901 8.84029 3.95416 8.70037 4.35476C8.56045 4.75535 8.50984 5.1817 8.55207 5.60392V7.38492H6.46707V9.80692H8.55207V16.0069H11.0461L11.0421 15.9999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.b24841ea364341bbb305cf15ee577209.svg";
export { ForwardRef as ReactComponent };